import { string } from "prop-types"
import React from "react"

export default function PricingRowTTC({ amount }) {
  return (
    <td>
      <p>{amount}</p>
    </td>
  )
}

PricingRowTTC.propTypes = {
  amount: string
}
